import React, { PureComponent } from 'react';
import AppRouter from './Router';
import { connect } from 'react-redux';
import { storageInfo } from './utils/storageUtils';
import { ToastContainer } from 'react-toastify';
import { initUserInfo } from './redux/actions/auth';


class App extends PureComponent{

    componentDidMount() {
        //初始化本地存储的用户信息到redux
        this.props.initUserInfo(storageInfo.getUserInfo());
      }

    render(){
        return(
            <>
             {/* 导入所有的路由 */}
            <AppRouter {...this.props} />
            {/* 这里需要放一个全局的Toast容器，这样方便在任意页面弹出Toast提示信息 */}
            <ToastContainer position="top-center" />
            </>
        )
    }
}
export default connect((state) => ({ userInfo: state.auth.userInfo }), {
    initUserInfo,
  })(App);